import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Point from "ol/geom/Point";
import { Vector as VectorLayer } from "ol/layer";
import LayerGroup from "ol/layer/Group";
import { EventListDto } from "~/api/GeneratedApi";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { eventDtoToEventData } from "./dataConverters";

export function addEventsToMap(map: Map, events: EventListDto[]): void {
  // Find the events layer and add the events as features
  map.getLayers().forEach((l) => {
    if (l instanceof LayerGroup) {
      l.getLayers().forEach((lay) => {
        if (
          lay.get("title") === LayerTitle.Events &&
          lay instanceof VectorLayer
        ) {
          const source = lay.getSource();
          // Clear the source before adding
          source.clear();
          const features: Feature<Geometry>[] = [];
          events.forEach((e) => {
            // Convert to internal type
            const convertedEvent = eventDtoToEventData(e);
            if (convertedEvent.expired) return;
            const point = new Point([
              convertedEvent.location.x,
              convertedEvent.location.y,
            ]);
            const feat = new Feature({
              geometry: point,
            });
            feat.setProperties({ ...convertedEvent });
            feat.set("overlayOffsetY", -24);
            feat.setId(convertedEvent.mapId);
            features.push(feat);
          });
          source.addFeatures(features);
          source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
          map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
        }
      });
    }
  });
}
